module.exports = __webpack_public_path__ + "img/27.bd54d209.jpg";